import { datadogRum } from '@datadog/browser-rum';

export interface DataDogConfig {
  buildVersion: string;
  environment: string;
}

export const initDatadogRum = ({
  buildVersion,
  environment,
}: DataDogConfig) => {
  datadogRum.init({
    applicationId: 'e1f82238-415c-4086-8f0d-5bed5f4dc0c6',
    clientToken: 'pub4ffd055e30b60969edf6062770ab242f',
    site: 'datadoghq.com',
    service: 'career-hub-web',
    env: environment,
    version: buildVersion,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });

  datadogRum.startSessionReplayRecording();
};
